/*----------------------------------------------- CUSTOMERS SECTION -----------------------------------------------*/
$(document).ready(function(){


  $('#customers .multiple-items').on('ready beforeChange', function(event, slick, currentSlide, nextSlide, preSlide){

    if ($(window).width() >= 1281) {

      $('#customers .slick-slide:not(.slick-active)').addClass('animated fadeInUp');
      $('#customers .multiple-items .fadeInUp').css({'animation-delay' : '300ms'});
      $('#customers .multiple-items .fadeInUp').css({'animation-duration' : '200ms'});


      setTimeout(function() { 
        $('#customers .slick-slide:not(.slick-active)').removeClass('animated fadeInUp');
      }, 1000);


      $('body').on('click', '.slick-next', function() {

        if (currentSlide == sliderCount - 1) {

          $('#customers .slick-slide.slick-center').removeClass('animated fadeInUp');
          $('#customers .slick-slide.slick-active').first().removeClass('animated fadeInUp');

        }
      });


      $('body').on('click', '.slick-prev', function() {
        if (currentSlide == 0) {
          $('#customers .slick-slide.slick-center').removeClass('animated fadeInUp');
          $('#customers .slick-slide.slick-active').last().removeClass('animated fadeInUp');
        }
      });

    }


  })
});
/*----------------------------------------------- CUSTOMERS SECTION (END) -----------------------------------------------*/



/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS -----------------------------------------------*/
$(document).ready(function() {
  $('#core .element-to-slideInLeft').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core .element-to-slideInLeft').waypoint(function() {
      $(this.element).addClass('slideInLeft');
      $(this.element).css('opacity', 1);
    }, 
                                                { offset: '95%' });
  }

  else {
    $('#core .element-to-slideInLeft').waypoint(function() {
      $(this.element).addClass('slideInLeft');
      $(this.element).css('opacity', 1);
    }, 
                                                { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#core .element-to-slideInRight').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core .element-to-slideInRight').waypoint(function() {
      $(this.element).addClass('slideInRight');
      $(this.element).css('opacity', 1);
    }, 
                                                 { offset: '95%' });
  }

  else {
    $('#core .element-to-slideInRight').waypoint(function() {
      $(this.element).addClass('slideInRight');
      $(this.element).css('opacity', 1);
    }, 
                                                 { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#core .element-to-slideInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                              { offset: '95%' });
  }

  else {
    $('#core .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                              { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#partners .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#partners .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                               { offset: '95%' });
  }

  else {
    $('#partners .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                               { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#quote .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#quote .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                            { offset: '95%' });
  }

  else {
    $('#quote .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                            { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#quote .element-to-fadeInDown').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#quote .element-to-fadeInDown').waypoint(function() {
      $(this.element).addClass('fadeInDown');
    }, 
                                                { offset: '95%' });
  }

  else {
    $('#quote .element-to-fadeInDown').waypoint(function() {
      $(this.element).addClass('fadeInDown');
    }, 
                                                { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#clients .element-to-fadeInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#clients .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
                                                { offset: '95%' });
  }

  else {
    $('#clients .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
                                                { offset: '125%' });   
  }
});



$(document).ready(function() {
  $('#steps .element-to-zoomIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#steps .element-to-zoomIn').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    }, 
                                            { offset: '95%' });
  }

  else {
    $('#steps .element-to-zoomIn').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    },
                                            { offset: '125%' });       
  }
});



$(document).ready(function() {
  $('#steps .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#steps .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                            { offset: '95%' });
  }

  else {
    $('#steps .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                            { offset: '125%' });    
  }
});



$(document).ready(function() {
  $('#privacy .element-to-fadeInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#privacy .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
                                                { offset: '95%' });
  }

  else {
    $('#privacy .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    },
                                                { offset: '125%' });
  }
});



$(document).ready(function() {
  $('#experts .element-to-fadeInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#experts .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
                                                { offset: '95%' });
  } 
  else {
    $('#experts .element-to-fadeInUp').waypoint(function() {
      $(this.element).addClass('fadeInUp');
    }, 
                                                { offset: '130%' }); 
  }
});



$(document).ready(function() {
  $('#core-package .element-to-slideInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#core-package .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                      { offset: '95%' });
  }

  else {
    $('#core-package .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                      { offset: '130%' });    
  }
});



$(document).ready(function() {

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#subscription-products .element-to-bounceInUp').waypoint(function() {
      $(this.element).addClass('bounceInUp');
    }, 
                                                                { offset: '100%' });
  }

  else {
    $('#subscription-products .element-to-bounceInUp').waypoint(function() {
      $(this.element).addClass('bounceInUp');
    }, 
                                                                { offset: '170%' });
  }
});



$(document).ready(function() {

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#homepage-products .element-to-bounceInUp').waypoint(function() {
      $(this.element).addClass('bounceInUp');
    }, 
                                                            { offset: '100%' });
  }

  else {
    $('#homepage-products .element-to-bounceInUp').waypoint(function() {
      $(this.element).addClass('bounceInUp');
    }, 
                                                            { offset: '170%' });
  }
});
/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS (END) -----------------------------------------------*/





/*----------------------------------------------- EXPERTS SECTION -----------------------------------------------*/
$(document).ready(function() {
  var expertsShowButtonClickCount = 0;

  $( "#experts .button-rounded-corners-border" ).on('click tap', function () {
    expertsShowButtonClickCount += 1;

    if ($(window).width() <= 439) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideDown({
          start: function () {
            $(this).css({'display': 'flex'})
          }
        });
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideUp()
      }
    };

    if (($(window).width() >= 440) && ($(window).width() <= 634)) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideDown({
          start: function () {
            $(this).css({'display': 'flex'})
          }
        });
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideUp()
      }
    };

    if (($(window).width() >= 635) && ($(window).width() <= 829)) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideDown({
          start: function () {
            $(this).css({'display': 'flex'})
          }
        });
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').slideUp()
      }
    };

    if (($(window).width() >= 830) && ($(window).width() <= 1024)) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideDown({
          start: function () {
            $(this).css({'display': 'flex'})
          }
        });
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').slideUp()
      }
    };  

    if ($(window).width() >= 1025) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').slideDown({
          start: function () {
            $(this).css({'display': 'flex'})
          }
        });
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').slideUp()
      }
    };
  });










  // IF WINDOW RESIZED
  $(window).resize(function() {

    if ($(window).width() <= 439) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'flex'});
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(-n+3)').css({'display' : 'flex'});
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'none'});
      }
    }

    if (($(window).width() >= 440) && ($(window).width() <= 634)) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'flex'});
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(-n+4)').css({'display' : 'flex'});
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'none'});
      }
    }

    if (($(window).width() >= 635) && ($(window).width() <= 829)) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'flex'});
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(-n+3)').css({'display' : 'flex'});
        $('#experts .image .expert:nth-child(n+4):nth-child(-n+10)').css({'display' : 'none'});
      }
    }

    if (($(window).width() >= 830) && ($(window).width() <= 1024)) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'flex'});
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(-n+4)').css({'display' : 'flex'});
        $('#experts .image .expert:nth-child(n+5):nth-child(-n+10)').css({'display' : 'none'});
      }
    }

    if ($(window).width() >= 1025) {
      if (expertsShowButtonClickCount % 2 == 1) {
        $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').css({'display' : 'flex'});
      }
      if (expertsShowButtonClickCount % 2 == 0) {
        $('#experts .image .expert:nth-child(-n+5)').css({'display' : 'flex'});
        $('#experts .image .expert:nth-child(n+6):nth-child(-n+10)').css({'display' : 'none'});
      }
    }

  });

});
/*----------------------------------------------- EXPERTS SECTION (END) -----------------------------------------------*/





/*----------------------------------------------- PARTNERS - MAP (TOOLTIP) -----------------------------------------------*/
// TOOLTIP
$(document).ready(function() {

  $('.tooltip').tooltipster({
    theme: ['tooltipster-light', 'tooltipster-light-customized'],
    arrow: 'boolean',
    animation: 'swing',
    distance: -15,
    side: 'right',
    delay: 0,
    interactive: 'boolean',
    trigger: 'hover'
  });

});
/*----------------------------------------------- PARTNERS - MAP (TOOLTIP) -----------------------------------------------*/



$(document).ready(function() {
  // BUTTON TEXT CHANGE
  $( "#experts .button-rounded-corners-border" ).on('click tap', function () {
    $(this).find('h4').text(function(i, text){
      return text === "See More" ? "See Less" : "See More";
    });
  });
});








/*----------------------------------------------- STORIES SECTION -----------------------------------------------*/
$(document).ready(function() {
  // SHOW FULLSCREEN ON CLICK
  $('#stories .prompt-video').on('click tap', function () {

    // SHOW/FADEINUP MODULE
    $('#stories .module').css('display', 'flex');
    $('#stories .module').addClass('slideInUp');

    // SHOW/FADEIN VIDEO-WRAPPER
    $('#stories .video-wrapper').css('display', 'flex');
    $('#stories .video-wrapper').addClass('fadeIn');

  })


  // CLOSING VIDEOS
  videoWrap = $('#stories .video-wrapper');

  // CLOSING VIDEOS - CLOSE BUTTON
  $("#stories .close-solera-module").on('click tap', function() {
    $("#stories .module").css({'display':'none'});
    $('#stories .module').removeClass('slideInUp');
    $('#stories .video-wrapper').removeClass('fadeIn');
    // RESET VIMEO 
    videoWrap.html(videoWrap.html());

  });

  // CLOSING VIDEOS - ESCAPE KEY
  $(window).keydown(function(event){
    if(event.keyCode == 27) {
      event.preventDefault();
      $("#stories .module").css({'display':'none'});
      $('#stories .module').removeClass('slideInUp');
      $('#stories .video-wrapper').removeClass('fadeIn'); 
    }
  }); 



  // Z-INDEX
  $('#stories .prompt-video').on('click tap', function () {
    $('#stories').css('z-index', '9999');
  });
  $("#stories .close-solera-module").on('click tap', function() {
    $('#stories').css('z-index', '0');
  });
  $(window).keydown(function(event){
    if(event.keyCode == 27) {
      if(!$('#stories .module').is(':visible')) {
        $('#stories').css('z-index', '0');
      }
    }
  }); 
});
/*----------------------------------------------- STORIES SECTION -----------------------------------------------*/


















/*----------------------------------------------- OUTCOMES SECTION -----------------------------------------------*/
$(document).ready(function() {
  var ailments1 = 75;
  var ailments2 = 75;
  var ailments3 = 66;
  var ailments4 = 66;
  var ailments5 = 50;

  // PREFIXES AND SUFFIXES
  var countUpOptions1 = { suffix: '%',};

  $('#outcomes .outcome-three').waypoint(function() {
    var demo = new CountUp('blue-count-1', 100, ailments1, 0, 1.5, countUpOptions1);
    demo.start();
    var demo = new CountUp('blue-count-2', 100, ailments2, 0, 1.5, countUpOptions1);
    demo.start(); 
    var demo = new CountUp('blue-count-3', 100, ailments3, 0, 1.5, countUpOptions1);
    demo.start(); 
    var demo = new CountUp('blue-count-4', 100, ailments4, 0, 1.5, countUpOptions1);
    demo.start();
    var demo = new CountUp('blue-count-5', 100, ailments5, 0, 1.5, countUpOptions1);
    demo.start();

    // PUT VARIABLE INTO WIDTH AND MULTIPLY BY 2.8 (DIV IS 280PX WIDE)
    $('#outcomes .outcome-three .line-items .line-item:nth-of-type(1) .bar .progress').css({'width' : ailments1*2.8 });
    $('#outcomes .outcome-three .line-items .line-item:nth-of-type(2) .bar .progress').css({'width' : ailments2*2.8 });
    $('#outcomes .outcome-three .line-items .line-item:nth-of-type(3) .bar .progress').css({'width' : ailments3*2.8 });
    $('#outcomes .outcome-three .line-items .line-item:nth-of-type(4) .bar .progress').css({'width' : ailments4*2.8 });
    $('#outcomes .outcome-three .line-items .line-item:nth-of-type(5) .bar .progress').css({'width' : ailments5*2.8 });
  },
                                         { offset: '86%' });

  // PUT VARIABLE INTO TOOLTIP
  $('#outcomes .outcome-three .line-items .line-item:nth-of-type(1) .bar .progress .tooltip h6').append('Reduced for <br><span>' + ailments1 + '%</span> of clients');
  $('#outcomes .outcome-three .line-items .line-item:nth-of-type(2) .bar .progress .tooltip h6').append('Reduced for <br><span>' + ailments2 + '%</span> of clients');
  $('#outcomes .outcome-three .line-items .line-item:nth-of-type(3) .bar .progress .tooltip h6').append('Reduced for <br><span>' + ailments3 + '%</span> of clients');
  $('#outcomes .outcome-three .line-items .line-item:nth-of-type(4) .bar .progress .tooltip h6').append('Reduced for <br><span>' + ailments4 + '%</span> of clients');
  $('#outcomes .outcome-three .line-items .line-item:nth-of-type(5) .bar .progress .tooltip h6').append('Reduced for <br><span>' + ailments5 + '%</span> of clients');
});



$(document).ready(function() {

  var weightLossDigbi = 8.92;
  var weightLossMd = 6.5;
  var weightLossCdc = 4.31;

  $('#outcomes .outcome-two .chart').waypoint(function() {
    // PUT VARIABLE INTO HEIGHT AND MULTIPLY BY 20 (DIV IS 200PX HIGH)
    $('#outcomes .outcome-two .chart .bar:nth-of-type(1) .progress').css({'height' : weightLossDigbi*20 });
    $('#outcomes .outcome-two .chart .bar:nth-of-type(2) .progress').css({'height' : weightLossMd*20 });
    $('#outcomes .outcome-two .chart .bar:nth-of-type(3) .progress').css({'height' : weightLossCdc*20 });

    // NOTE, THE .TEXT CLEARS OUT, WHICH IS IMORTANT, BECAUSE SOMETIMES OTHER JS ACTIONS ON THE PAGE ARE DUPLICATING THE VARIABLE IN THE H6 ELEMENT
    $('#outcomes .outcome-two .chart .bar:nth-of-type(1) .progress .tooltip h6').text('').append('<span>' + weightLossDigbi + '%</span> avg<br> weight-loss');
    $('#outcomes .outcome-two .chart .bar:nth-of-type(2) .progress .tooltip h6').text('').append('<span>' + weightLossMd + '%</span> avg<br> weight-loss');
    $('#outcomes .outcome-two .chart .bar:nth-of-type(3) .progress .tooltip h6').text('').append('<span>' + weightLossCdc + '%</span> avg<br> weight-loss');
  }, 
                                              { offset: '100%' });
});
/*----------------------------------------------- OUTCOMES SECTION (END) -----------------------------------------------*/



















/*----------------------------------------------- ENDORSEMENTS SECTION -----------------------------------------------*/
$(document).ready(function(){  
  $('#endorsements .multiple-items').on('ready beforeChange', function(event, slick, currentSlide, nextSlide, preSlide){


    if ($(window).width() >= 1281) {
      $('#endorsements .slick-slide:not(.slick-active)').addClass('animated fadeInUp');
      $('#endorsements .multiple-items .fadeInUp').css({'animation-delay' : '300ms'});
      $('#endorsements .multiple-items .fadeInUp').css({'animation-duration' : '200ms'});


      setTimeout(function() { 
        $('#endorsements .slick-slide:not(.slick-active)').removeClass('animated fadeInUp');
      }, 1000);


      $('body').on('click', '.slick-next', function() {
        if (currentSlide == sliderCount - 1) {

          $('#endorsements .slick-slide.slick-center').removeClass('animated fadeInUp');
          $('#endorsements .slick-slide.slick-active').first().removeClass('animated fadeInUp');

        }
      });


      $('body').on('click', '.slick-prev', function() {
        if (currentSlide == 0) {
          $('#endorsements .slick-slide.slick-center').removeClass('animated fadeInUp');
          $('#endorsements .slick-slide.slick-active').last().removeClass('animated fadeInUp');
        }
      });

    }


  })
});
/*----------------------------------------------- ENDORSEMENTS SECTION (END) -----------------------------------------------*/













/*----------------------------------------------- SCIENCE SECTION -----------------------------------------------*/
$(document).ready(function() {
  // SHOW FULLSCREEN ON CLICK
  $('#science .prompt-video').on('click tap', function () {

    // SHOW/FADEINUP MODULE
    $('#science .module').css('display', 'flex');
    $('#science .module').addClass('slideInUp');

    // SHOW/FADEIN VIDEO-WRAPPER
    $('#science .video-wrapper').css('display', 'flex');
    $('#science .video-wrapper').addClass('fadeIn');

  })


  // CLOSING VIDEOS
  videoWrap = $('#science .video-wrapper');

  // CLOSING VIDEOS - CLOSE BUTTON
  $("#science .close-solera-module").on('click tap', function() {
    $("#science .module").css({'display':'none'});
    $('#science .module').removeClass('slideInUp');
    $('#science .video-wrapper').removeClass('fadeIn');
    // RESET VIMEO 
    videoWrap.html(videoWrap.html());

  });

  // CLOSING VIDEOS - ESCAPE KEY
  $(window).keydown(function(event){
    if(event.keyCode == 27) {
      event.preventDefault();
      $("#science .module").css({'display':'none'});
      $('#science .module').removeClass('slideInUp');
      $('#science .video-wrapper').removeClass('fadeIn'); 
    }
  }); 



  // Z-INDEX
  $('#science .prompt-video').on('click tap', function () {
    $('#science').css('z-index', '9999');
  });
  $("#science .close-solera-module").on('click tap', function() {
    $('#science').css('z-index', '0');
  });
  $(window).keydown(function(event){
    if(event.keyCode == 27) {
      if(!$('#science .module').is(':visible')) {
        $('#science').css('z-index', '0');
      }
    }
  }); 
});
/*----------------------------------------------- SCIENCE SECTION -----------------------------------------------*/



















/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS -----------------------------------------------*/
$(document).ready(function() {
  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#science .element-to-slideInUp').css('opacity', 0);
    $('#science .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                 { offset: '100%' });
  }
});






$(document).ready(function() {
  $('#cobesity .element-to-animate').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#cobesity .element-to-animate').waypoint(function() {
      $(this.element).addClass('fadeInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                { offset: '85%' });
  }

  else {
    $('#cobesity .element-to-animate').waypoint(function() {
      $(this.element).addClass('fadeInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                { offset: '130%' });    
  }
});



$(document).ready(function() {
  $('#industries .element-to-slideInUp').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#industries .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                    { offset: '85%' });
  }

  else {
    $('#industries .element-to-slideInUp').waypoint(function() {
      $(this.element).addClass('slideInUp');
      $(this.element).css('opacity', 1);
    }, 
                                                    { offset: '130%' });    
  }
});



$(document).ready(function() {
  $('#industries .element-to-zoomIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#industries .element-to-zoomIn').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    }, 
                                                 { offset: '80%' });
  }

  else {
    $('#industries .element-to-zoomIn').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    }, 
                                                 { offset: '130%' });    
  }
});



$(document).ready(function() {
  $('#industries .element-to-slideInDown').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#industries .element-to-slideInDown').waypoint(function() {
      $(this.element).addClass('slideInDown');
      $(this.element).css('opacity', 1);
    }, 
                                                      { offset: '75%' });
  }

  else {
    $('#industries .element-to-slideInDown').waypoint(function() {
      $(this.element).addClass('slideInDown');
      $(this.element).css('opacity', 1);
    }, 
                                                      { offset: '130%' });    
  }
});



$(document).ready(function() {
  $('#associates .element-to-fadeIn').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#associates .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                                 { offset: '95%' });
  }

  else {
    $('#associates .element-to-fadeIn').waypoint(function() {
      $(this.element).addClass('fadeIn');
    }, 
                                                 { offset: '130%' });    
  }
});



$(document).ready(function() {
  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#security .element-to-lightSpeedIn').css('opacity', 0);
    $('#security .element-to-lightSpeedIn').waypoint(function() {
      $(this.element).addClass('lightSpeedIn');
      $(this.element).css('opacity', 1);
    }, 
                                                     { offset: '100%' });
  }
});



$(document).ready(function() {
  $('#diagram .image > div > img').css('opacity', 0);

  if(window.matchMedia("(min-width: 769px)").matches) {
    $('#diagram .image > div > img').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    }, 
                                              { offset: '95%' });
  }

  else {
    $('#diagram .image > div > img').waypoint(function() {
      $(this.element).addClass('zoomIn');
      $(this.element).css('opacity', 1);
    }, 
                                              { offset: '130%' });    
  }
});

/*----------------------------------------------- GENERAL ANIMATE.CSS & WAYPOINT ANIMATIONS (END) -----------------------------------------------*/